import {
    ButtonNew,
    Input,
    LuneThemeNew,
    LuneThemeProvider,
    Modal,
    Text,
} from '@lune-fe/lune-ui-lib'
import { useState } from 'react'
import ReactDOM from 'react-dom/client'

const AddMapValueModal = ({ onModalClose }: { onModalClose: (selection?: string) => void }) => {
    const [value, setValue] = useState<string>('')

    return (
        <LuneThemeProvider theme={LuneThemeNew}>
            <Modal
                maxWidth={'md'}
                open={true}
                onClose={() => onModalClose(undefined)}
                header={<Text variant={'h5'}>New mapping value</Text>}
                actions={
                    <>
                        <ButtonNew style={'outline'} onClick={() => onModalClose(undefined)}>
                            Cancel
                        </ButtonNew>
                        <ButtonNew onClick={() => onModalClose(value)}>Add mapping</ButtonNew>
                    </>
                }
            >
                <Input
                    autoFocus
                    sx={{
                        margin: '4px',
                        flex: '1 1 100%',
                    }}
                    placeholder={'Mapping value'}
                    value={value}
                    onChange={(e) => {
                        setValue(e.target.value)
                    }}
                    data-testid={`order-amount-input`}
                ></Input>
            </Modal>
            ,
        </LuneThemeProvider>
    )
}

export const showAddMapValueModal = ({
    handleSelection,
}: {
    handleSelection: (selection?: string) => void
}): Promise<string | undefined> => {
    return new Promise((resolve) => {
        const container = document.createElement('div')
        document.body.appendChild(container)
        const root = ReactDOM.createRoot(container)

        const handleClose = (selection?: string) => {
            resolve(selection)
            handleSelection(selection)
            setTimeout(() => {
                root.unmount()
                container.remove()
            }, 0)
        }

        root.render(<AddMapValueModal onModalClose={handleClose}></AddMapValueModal>)
    })
}
